module.exports = __webpack_public_path__ + "img/5.22928bbb.jpg";